import { Model } from "@vuex-orm/core";
import type { Fields } from "@vuex-orm/core";
import type { Config } from "@vuex-orm/plugin-axios";
import Download from "@models/Download";
import Video from "@models/Video";
import Publication from "@models/Publication";

export default class VideoExport extends Model {
  public static entity = "videoExports";

  public static get apiConfig(): Config {
    return {
      baseURL: "/api/v1/captures",
    };
  }

  public static fields(): Fields {
    return {
      id: this.number(-1),
      status: this.attr(null),
      videoId: this.number(-1),
      video: this.belongsTo(Video, "videoId"),
      publicationId: this.number(-1),
      publication: this.belongsTo(Publication, "publicationId"),
      videoFileUrl: this.string(null).nullable(),
      download: this.hasOne(Download, "videoExportId"),
      createdAt: this.attr(""),
      failureReason: this.string(""),
    };
  }

  public id!: number;

  public status!: string;

  public videoId!: number;

  public publicationId!: number;

  public videoFileUrl!: string | null;

  public download!: Download | undefined;

  public createdAt!: string;

  public failureReason!: string;

  public downloadFile(): void {
    console.log("VideoExport.downloadFile", this);
    if (!this.videoFileUrl) return;
    Download.insertOrUpdate({ data: { url: this.videoFileUrl, videoExportId: this.id } });
  }

  public get isDownloadable(): boolean {
    return ["completed", "downloaded"].includes(this.status);
  }

  public get hasFailed(): boolean {
    return this.status === "failed";
  }

  public get isRunning(): boolean {
    return !this.isDownloadable && !this.hasFailed;
  }
}
